import React from 'react';
import { css } from '@emotion/react';

import NvFroala from 'froala/components/nv-froala';
import { FroalaViewMode, ToolbarOptions, UploadType } from 'froala/helpers/nv-froala-constants';
import { SanitizationLevel } from 'froala/helpers/sanitizer';

import { EditableActivity } from 'redux/schemas/models/edit-translations';

import { gray5, white } from 'styles/global_defaults/colors';
import { doubleSpacing, halfSpacing, quarterSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';
import NvTextArea from 'shared/components/inputs/nv-text-area';


type EditableProps = {
  activity: EditableActivity,
  setActivity: (EditableActivity) => void,
  containerClass: string,
  titleName: string,
  descriptionName?: string,
};

const EditableTitleWithDescriptionStyled = ({
  activity,
  setActivity,
  containerClass,
  titleName,
  descriptionName,
}: EditableProps) => {
  const descriptionStyles = css`
    margin: 0 ${doubleSpacing}px;
    .bs4-form-control {
      background: ${white};
    }
    .tag {
      margin-bottom: ${halfSpacing}px;
      padding: 3px 12px 3px;
      border-radius: ${halfSpacing}px;
      height: ${standardSpacing}px;
      width: fit-content;
    }
    .activity-header {
      .fr-element {
        align-content: center;
        p {
          margin: 0;
        }
      }
      &.border-simple-text {
        border-radius: ${quarterSpacing}px;
        border-color: ${gray5};
      }
    }
    .activity-content {
      margin-top: ${standardSpacing}px;
    }
  `;
  return (
    <div className='activity' css={descriptionStyles}>
      <div className='tag bg-gray-6 text-small font-weight-bolder'>
        { titleName }
      </div>
      <NvTextArea
        value={activity.title}
        autoComplete='off'
        textareaClassName='text-large-body border-simple-text activity-header'
        onChange={(e) => { setActivity({ ...activity, title: e.currentTarget?.value }); }}
      />
      {
        activity.description && (
          <div className='activity-content'>
            <div className='tag bg-gray-6 text-small font-weight-bolder'>
              { descriptionName }
            </div>
            <NvFroala
              className='activity-content-froala'
              preset={FroalaViewMode.NORMAL}
              sanitizationLevel={SanitizationLevel.BASIC}
              toolbarButtons={[
                ToolbarOptions.COLOR,
                ToolbarOptions.BOLD,
                ToolbarOptions.ITALIC,
                ToolbarOptions.UNDERLINE,
                ToolbarOptions.FORMAT_UL,
                ToolbarOptions.FORMAT_OL,
                ToolbarOptions.PARAGRAPH_STYLE,
                ToolbarOptions.ALIGN,
                ToolbarOptions.INSERT_LINK,
              ]}
              minHeight={65}
              uploadType={UploadType.ALL}
              value={activity.description}
              onChange={(newDescription) => setActivity({ ...activity, description: newDescription })}
              colorPickerContainer={containerClass}
            />
          </div>
        )
      }
    </div>
  );
};

export default EditableTitleWithDescriptionStyled;
